import { ReactNode, useEffect } from "react";

import { ScopeType } from "sockapi/scope-types";
import {
  PuzzleSubmissionType,
  AdminQueueTaskType,
} from "sockapi/scope-specs/admin-queue-task-spec";
import {
  useScopeStateResolvable,
  useGlobalScopeState,
} from "stores/ScopeStateStore";
import { useNavStore } from "stores/NavStore";
import { useAdminPreferencesStore } from "stores/UserPreferencesStore";
import { Spinner } from "components/Loading";
import { Link } from "components/Link";
import ClaimedBy from "components/AdminQueue/ClaimedBy";
import { HintAdminQueueTaskDisplay } from "components/AdminQueue/admin-queue-hint";

export function AdminQueueTaskDisplay(props: { taskId: string }) {
  const { taskId } = props;
  const adminQueueScopeState = useGlobalScopeState(ScopeType.ADMIN_QUEUE);
  const adminQueueTaskScopeState = useScopeStateResolvable(
    ScopeType.ADMIN_QUEUE_TASK,
    {
      taskId,
    }
  );
  const staffId = useAdminPreferencesStore((state) => state.staffId);
  const taskSummary = adminQueueScopeState?.tasks[taskId] ?? null;
  const setRedirectRoute = useNavStore((state) => state.setRedirectRoute);

  useEffect(() => {
    if (adminQueueScopeState === null) return;
    if (taskSummary === null) {
      toastr.error("Unknown task.");
      setRedirectRoute({ route: "admin_queue", replace: true });
    }
  }, [adminQueueScopeState, taskSummary, setRedirectRoute]);

  if (taskSummary === null || adminQueueTaskScopeState === null)
    return <Spinner inline={true} />;
  const { task, claim } = adminQueueTaskScopeState;
  const isClaimedBySelf = claim !== undefined && claim.staffId === staffId;

  return (
    <>
      <div className="admin-queue-header">
        <div className="admin-queue-task-claim-control">
          <ClaimedBy taskId={taskId} taskSummary={taskSummary} />
          <div>
            <Link route="admin_queue" button={true}>
              Back
            </Link>
          </div>
        </div>
      </div>
      <div className="admin-queue-task-body">
        {((): NonNullable<ReactNode> => {
          switch (task.type) {
            case AdminQueueTaskType.HINT:
              return (
                <HintAdminQueueTaskDisplay
                  taskId={taskId}
                  hintId={task.hintId}
                  isClaimedBySelf={isClaimedBySelf}
                />
              );
            case AdminQueueTaskType.PUZZLE_SUBMISSION:
              switch (task.submissionType) {
                case PuzzleSubmissionType.DUMMY:
                  return <>Dummy</>;
              }
          }
        })()}
      </div>
    </>
  );
}
